import { render, staticRenderFns } from "./TemporaryReservationCode.vue?vue&type=template&id=ee70a0a0&scoped=true&"
import script from "./TemporaryReservationCode.vue?vue&type=script&lang=js&"
export * from "./TemporaryReservationCode.vue?vue&type=script&lang=js&"
import style0 from "./TemporaryReservationCode.vue?vue&type=style&index=0&id=ee70a0a0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee70a0a0",
  null
  
)

export default component.exports